import { Link } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

const CardBody = ({ data: { body, header, link }, long = false }) => (
  <div className={`body ${long ? 'long' : ''}`}>
    <div className={`header ${long ? 'long' : ''}`}>{header}</div>
    <div className={`content ${long ? 'long' : ''}`}>
      <div className="snippet">{body}</div>
      {link && (
        <div className="link">
          <Link to={`${link.url}/`}>{link.title}</Link>
        </div>
      )}
    </div>
  </div>
);

CardBody.propTypes = {
  data: PropTypes.object,
  long: PropTypes.bool,
};

export default CardBody;
